import FoodCategoryMenuIcon from '@assets/offer/food-category-menu.png';
import RestaurantOfferStore from "@components/offer/stores/RestaurantOfferStore";
import { Box, CssBaseline, Fab, SwipeableDrawer, styled } from "@mui/material";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import FoodCategoryList from "./FoodCategoryList";

interface FoodCategoryDrawerProps {
    restaurantOfferStore: RestaurantOfferStore,
}

const FoodCategoryDrawer: FC<FoodCategoryDrawerProps> = observer(({ restaurantOfferStore }) => {
    const { isFoodCategoryDrawerOpen, setIsFoodCategoryDrawerOpen } = restaurantOfferStore;

    return (
        <>
            <CssBaseline />
            <SwipeableDrawer
                sx={{
                    ".MuiDrawer-paper ": {
                        borderTopLeftRadius: 14,
                        borderTopRightRadius: 14,
                        height: "78%"
                    },

                }}
                anchor="bottom"
                open={isFoodCategoryDrawerOpen}
                onClose={() => setIsFoodCategoryDrawerOpen(false)}
                onOpen={() => setIsFoodCategoryDrawerOpen(true)}
                disableSwipeToOpen
                ModalProps={{
                    keepMounted: false,
                }}
            >
                <Box
                    sx={(theme) => ({
                        position: 'relative',
                        border: 9,
                        // backgroundColor: theme.palette.primary.main,
                        borderColor: "Background",
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                    })}
                >
                    <Puller />
                </Box>
                <Box
                    sx={{
                        height: '100%',
                        overflow: 'auto',
                    }}
                >
                    <FoodCategoryList restaurantOfferStore={restaurantOfferStore} />
                </Box>
            </SwipeableDrawer >

            <Fab
                sx={(theme) => ({
                    position: "fixed",
                    borderRadius: 1,
                    bottom: 16,
                    right: 16,
                    backgroundColor: theme.palette.primary.main,
                    // border: 2,
                    // borderColor: theme.palette.secondary.light,
                    // boxShadow: theme.shadows[5],
                    boxShadow: "0px 1px 5px -1px rgba(0,0,0,0.2), 0px 4px 8px 0px rgba(0,0,0,0.14), 0px 1px 12px 0px rgba(0,0,0,0.12)",
                    ":focus": {
                        backgroundColor: theme.palette.primary.main,
                    },
                    ":hover": {
                        backgroundColor: theme.palette.primary.main,
                    }
                })}
                size='large'
                onClick={() => setIsFoodCategoryDrawerOpen(true)}>
                <img src={FoodCategoryMenuIcon} alt="food-category-menu" height={48} />
            </Fab>
        </>
    )
})

export default FoodCategoryDrawer;

const Puller = styled(Box)(({ theme }) => ({
    width: 52,
    height: 6,
    zIndex: 1,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 50,
    border: `1px solid ${theme.palette.grey[300]}`,
    position: 'absolute',
    top: -3,
    left: 'calc(50% - 26px)',
}));